import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { FiServer, FiZap, FiX } from 'react-icons/fi';

import BSButton from 'Components/Button/BSButton';
import Styles from './../Editor.module.scss';
import { ROUTES } from 'constants/routes';
import { updateDocument } from 'services/documentService';
import { StatusOptions } from 'Components/Status/StatusOption';
import { circularProgressbarStyle } from 'styles/score';
import { CircularProgressbar } from 'react-circular-progressbar';
import { BsCloudCheck } from 'react-icons/bs';
import VerticalSeparator from 'Components/Separator/VerticalSeparator';
import { getScoreInfo } from 'helpers/score';
import BreadcrumbReactstrap from 'Components/BreadcrumbReactstrap/BreadcrumbReactstrap';
import { MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { CONTENT_TYPE_ICONS } from 'constants/contentTypes';
import { ReactComponent as Other } from '../../../assets/svg/Group.svg';

const SelectStyles = {
  option: (styles, { isSelected, isFocused }) => {
    return {
      boxShadow: isFocused ? null : null,
      backgroundColor: isSelected ? '#e5e5e5' : '#fff',
      background: isSelected ? `url("./Images/tickDark.svg")` : '',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: '500',
      color: '#344054',
      height: '100%',
      padding: '6px 10px',

      '&:hover': {
        backgroundColor: 'lightgrey',
        cursor: 'pointer',
      },
    };
  },

  control: (baseStyles) => {
    return {
      ...baseStyles,
      cursor: 'pointer',
    };
  },
};

function EditorHeader({
  document,
  docHealth,
  aiTitle,
  lastUpdated,
  showDocHealth,
  shouldShowContentSettings,
  isComment,
  setShowTemplateDrawer,
  briefId,
  setShowBriefDrawer,
  contentSidebarCollapse,
  documentHeaderTab,
  setDocumentHeaderTab,
  contentType,
  splitScreenMode,
  onExitSplitScreen,
}) {
  const [status, setStatus] = useState(document?.status || '');

  const { documentId } = useParams() || {};

  const navigate = useNavigate();

  useEffect(() => {
    if (
      aiTitle &&
      (!document.title || document.title === 'Untitled Document')
    ) {
      updateDocument(documentId, { title: aiTitle });
    }
  }, [aiTitle]);

  const handleChange = async (value) => {
    setStatus(value);
    await updateDocument(documentId, { status: value });
  };

  useEffect(() => {
    showDocHealth();
  }, []);
  const { overallScore } = getScoreInfo(docHealth);

  return (
    <div className="position-relative">
      <section className="document-header">
        <div className="d-flex align-items-center gap-4 flex-grow-1">
          {/* {!isComment && (
            <Select
              isSearchable={false}
              classNamePrefix="headerSelect"
              className="headerSelect"
              styles={SelectStyles}
              options={StatusOptions}
              value={StatusOptions.find((option) => option.value === status)}
              onChange={({ value }) => handleChange(value)}
            />
          )} */}
          <div className={Styles.documentStatusWrapper}>
            <div className="last-changed flex-d-row">
              <div className="d-flex align-items-center gap-3">
                <BreadcrumbReactstrap
                  documentHeaderTab={documentHeaderTab}
                  setDocumentHeaderTab={setDocumentHeaderTab}
                />
                {contentType && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '4px 12px',
                    borderRadius: '6px',
                    backgroundColor: '#F9FAFB',
                    border: '1px solid #E4E7EC',
                    fontSize: '13px',
                    fontWeight: '500',
                    color: '#344054',
                    fontFamily: 'DM Sans',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '16px', height: '16px' }}>
                      {CONTENT_TYPE_ICONS[contentType] || <Other width={16} height={16} />}
                    </div>
                    <span>{contentType}</span>
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center gap-2">
                <BsCloudCheck size={16} color="#475467" />
                <span
                  onClick={() => navigate(ROUTES.DocumentHistory(document.id))}
                  style={{
                    cursor: 'pointer',
                    color: '#667085',
                    fontFamily: 'DM Sans',
                    fontSize: '14px',
                    lineHeight: '20px',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Saved {moment(new Date(lastUpdated.updatedAt)).fromNow()} by{' '}
                  {lastUpdated.updatedBy}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.health_section}>
          {/* Exit Split Screen Button */}
          {splitScreenMode && onExitSplitScreen && (
            <button
              onClick={onExitSplitScreen}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                cursor: 'pointer',
                borderRadius: '8px',
                backgroundColor: '#FEF3F2',
                border: '1px solid #FEC2C0',
                color: '#D92D20',
                fontSize: '13px',
                fontWeight: '500',
                fontFamily: 'DM Sans',
                marginRight: '12px',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#FEE4E2';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FEF3F2';
              }}
            >
              <FiX size={14} />
              Exit AI Mode
            </button>
          )}
          {(contentSidebarCollapse || splitScreenMode) ? (
            /* Collapsed Document Health Score Indicator - Show when sidebar is closed or in split mode */
            <div
              onClick={showDocHealth}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                cursor: 'pointer',
                borderRadius: '8px',
                transition: 'background 0.2s ease',
                fontSize: '14px',
                fontWeight: '500',
                color: '#344054',
                fontFamily: 'DM Sans',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#F9FAFB';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <span style={{ color: '#667085' }}>Document Health:</span>
              <span style={{ color: '#00A7B7', fontWeight: '600' }}>
                {overallScore}/100
              </span>
              <span
                style={{
                  color: '#00A7B7',
                  fontSize: '13px',
                }}
              >
                Preview
              </span>
            </div>
          ) : (
            /* Sleek Collapse Button - Only show when sidebar is open */
            <div
              onClick={showDocHealth}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                backgroundColor: 'transparent',
                border: '1px solid #D0D5DD',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#F9FAFB';
                e.currentTarget.style.borderColor = '#00A7B7';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = '#D0D5DD';
              }}
            >
              <MdOutlineKeyboardDoubleArrowRight
                size={20}
                style={{ color: '#667085' }}
              />
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default EditorHeader;
